import { render, staticRenderFns } from "./oms.vue?vue&type=template&id=cba9a892&scoped=true"
import script from "./oms.vue?vue&type=script&lang=js"
export * from "./oms.vue?vue&type=script&lang=js"
import style0 from "./oms.vue?vue&type=style&index=0&id=cba9a892&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cba9a892",
  null
  
)

export default component.exports